// extracted by mini-css-extract-plugin
export default {"list":"Header_list__mFn5z"};